var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass:
        "m-nav__item m-topbar__user-profile m-topbar__user-profile--img m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light",
      attrs: { "data-dropdown-toggle": "click" }
    },
    [
      _c(
        "a",
        { staticClass: "m-nav__link m-dropdown__toggle", attrs: { href: "#" } },
        [
          _c("span", {
            staticClass:
              "m-nav__link-badge m-badge m-badge--dot m-badge--info m--hide"
          }),
          _vm._v(" "),
          _c("span", { staticClass: "m-nav__link-icon" }, [
            _c("span", { staticClass: "m-nav__link-icon-wrapper" }, [
              _c("i", {
                staticClass: "flaticon-stopwatch notification-i",
                attrs: {
                  title: _vm._f("capitalize")(
                    _vm._f("translate")("quick_actions")
                  )
                }
              })
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "m-dropdown__wrapper" }, [
        _c("span", {
          staticClass:
            "m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust arrow-user"
        }),
        _vm._v(" "),
        _c("div", { staticClass: "m-dropdown__inner" }, [
          _c(
            "div",
            {
              staticClass: "m-dropdown__header m--align-center",
              staticStyle: {
                background:
                  "url(assets/app/media/img/misc/quick_actions_bg.jpg)",
                "background-size": "cover"
              }
            },
            [
              _c("span", { staticClass: "m-dropdown__header-title" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm._f("capitalize")(_vm._f("translate")("quick_actions"))
                    ) +
                    "\n          "
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "m-dropdown__header-subtitle" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm._f("capitalize")(_vm._f("translate")("shortcuts"))
                    ) +
                    "\n          "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "m-dropdown__body m-dropdown__body--paddingless" },
            [
              _c("div", { staticClass: "m-dropdown__content" }, [
                _c(
                  "div",
                  {
                    staticClass: "m-scrollable",
                    attrs: {
                      "data-scrollable": "false",
                      "data-max-height": "380",
                      "data-mobile-max-height": "200"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "m-nav-grid m-nav-grid--skin-light" },
                      [
                        _c("div", { staticClass: "m-nav-grid__row" }, [
                          _c(
                            "a",
                            { staticClass: "m-nav-grid__item" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "m-nav-grid__item",
                                  attrs: { to: { name: "cameras" } }
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "m-nav-grid__icon flaticon-profile"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "m-nav-grid__text" },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm._f("capitalize")(
                                              _vm._f("translate")("cameras")
                                            )
                                          ) +
                                          "\n                      "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            { staticClass: "m-nav-grid__item" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "m-nav-grid__item",
                                  attrs: { to: { name: "adminControlPoints" } }
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "m-nav-grid__icon flaticon-map-location"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "m-nav-grid__text" },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm._f("capitalize")(
                                              _vm._f("translate")(
                                                "control_points"
                                              )
                                            )
                                          ) +
                                          "\n                      "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "m-nav-grid__row" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "m-nav-grid__item",
                                attrs: { to: { name: "createStaff" } }
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "m-nav-grid__icon flaticon-folder"
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "m-nav-grid__text" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("capitalize")(
                                            _vm._f("translate")("new_staff")
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              { staticClass: "m-nav-grid__item" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "m-nav-grid__item",
                                    attrs: { to: { name: "createCargoStaff" } }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "m-nav-grid__icon flaticon-clipboard"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "m-nav-grid__text" },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm._f("capitalize")(
                                                _vm._f("translate")(
                                                  "new_cargo_staff"
                                                )
                                              )
                                            ) +
                                            "\n                      "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              ])
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-610b66f2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-610b66f2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/layout/navbar/QuickActions.vue
// module id = 559
// module chunks = 0 54 132 174